import deleteRecord from '@/utils/delete-record'
import updateRecord from '@/utils/update-record'

const defaultOptions = {
  label: null,
  toaster: 'default',
  component: 'app-toast',
  timeout: 8000
}

function tinyId () {
  return (Math.floor(Math.random() * 1e6)).toString(16)
}

const getDefaultState = () => {
  return {
    messages: []
  }
}

const state = getDefaultState()

const actions = {
  addMessage (context, _payload) {
    const payload = Object.assign({}, defaultOptions, _payload)

    if (!payload.timestamp) {
      payload.timestamp = new Date()
    }

    context.commit('addMessage', payload)
  },

  removeMessage (context, { id }) {
    context.commit('removeMessage', { id })
  },

  resetState (context) {
    context.commit('resetState')
  }
}

const mutations = {
  addMessage ({ messages }, payload) {
    const { label } = payload
    if (label) {
      const message = messages.find(message => message.label === label)
      if (message) {
        payload.id = message.id
        return updateRecord(messages, payload)
      }
    }

    payload.id = tinyId()
    messages.push(payload)
  },

  removeMessage ({ messages }, { id }) {
    deleteRecord(messages, id)
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations
})
